<template>
    <div class="pa-3">
        <!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'vacationOrPermissionType/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="getAll()">
			<!-- {{ $T('.delete-message') }} -->
			هل أنت متأكد من أنك تريد حذف  نوع الأذن هذا ؟
		</v-delete-dialog>

        <!-- dialog -->
		<v-dialog v-model="dialog" max-width="300">
			<v-form ref="form" @submit.prevent="submit" :disabled="submitLoading">
				<v-card>
					<v-card-title>
						<span class="me-n6">
							{{
								(!itemId ? $T('add') : $T('edit')) +
								' ' +
								'أذن'
							}}
						</span>
						<v-spacer />
						<v-btn
							icon
							@click="dialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-3">
						<v-row dense class="ma-0">
							<!-- name -->
							<v-col cols="12">
								<v-text-field
									v-model="name"
									:label="$T('inputs.name')"
									hide-details
									dense
									outlined
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="secondary"
							type="submit"
							:loading="submitLoading"
						>{{ $T('save') }}</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
        <v-row>
            <v-col cols="auto">
                <v-autocomplete
                    v-model="permissionTypeId"
                    :items="permissions"
                    item-text="name"
                    item-value="id"
                    label="نوع الأذن "
                    outlined
                    dense
                    hide-details
                    clearable
                />
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn
                    @click="dialog = true"
                    small
                    dark
                    depressed
                    color="primary">
                    <v-icon left> $add </v-icon>
                    إضافة نوع أذن 
                </v-btn>
            </v-col>
        </v-row>

        <bee-handy-table
            :headers="permissionHeaders"
            :items="permissionTypeId ? permissions.filter(c => c.id === permissionTypeId) : permissions"
            :items-per-page="-1"
            hide-default-footer
            dense
            zebra
            :loading="loading"
            class="mt-2"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-btn 
                        @click="itemId= item.id; dialog = true"  
                        icon
                        color="edit-color"
                    >
                        <v-icon left>$edit</v-icon>
                    </v-btn>
    
                    <v-btn 
                        @click="itemId= item.id; deleteDialog = true"  
                        icon
                        color="alert-color"
                    >
                        <v-icon left>$delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import attendance from '../../../store/modules/attendance';
import validationRules from '@/utils/validation rules';
// 		fetch-store="attendance/fetchPermissionsTypes"
// add-store="attendance/addPermissionType"
export default {
    name: 'add-permission-type',
    mixins: [attendance],
    watch: {
        dialog(val) {
            if(!val) {
                this.$refs.form.resetValidation()
                this.name = null
                this.itemId = null
            } else {
                this.name = this.permissions.find(c => c.id === this.itemId)?.name
            }
        }
    },
    data() {
        return {
            loading: false,
            dialog: false,
            submitLoading: false,
            name: null,
            permissionHeaders: [
				{
					text: 'الاسم',
					name: 'name',
					value: 'name',
					storeName: 'name',
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true,
					sortable: false,
				},
			],
            itemId: null,
            rules: {
				...validationRules
            },
            deleteDialog: false,
            permissionTypeId: null,
            permissions: []
        }
    },

    computed: {
        ...mapState({
            // permissions: state => state.leaveOrPermission.permissions
        })
    },

    methods: {
        getAll() {
            this.loading = true
            return this.$store.dispatch('attendance/fetchPermissionsTypes').then((data) => {
                this.permissions = data
            }).finally(() => {
                this.loading = false
            })
        },

        submit() {
            this.submitLoading = true 
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`leaveOrPermission/${actionName}`, {
                id: this.itemId ? this.itemId : null,
                name: this.name,
                maxCount: 0,
                withSalary: false,
                discountPercentage: 0,
                repetition: 0,
                type: 1,
                employeeIds: []
            }).then(() => {
                this.getAll()
            }).finally(() => {
                this.submitLoading = false
                this.dialog = false
            })
        }
    },

    created() {
        this.getAll()
    }
}
</script>
